<template>
	<v-main>
		<v-container fluid class="ma-0 pa-0" :key="$route.fullPath">
			<v-col class="ma-0 pa-0" cols="12" id="login_view"
				v-if="this.$store.state.isMobile == false">
				<v-col class="ma-0 pa-0" cols="12">
					<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header">
						<v-row class="ma-0 pa-0" align="center">
							<v-col class="ma-0 pa-0 ml-2" cols="auto">
								<v-img height="40px" class="header_logo ma-0 pa-0" contain
									src="@/assets/images/usen_group_inv.png"></v-img>
							</v-col>
							<v-col class="ma-0 pa-0 ml-2" cols="auto">
								<v-col class="ma-0 pa-0" style="height: 40px; width: 8rem;"
									@click="adminLoginBtnCount = adminLoginBtnCount + 1">
									{{' '}}
								</v-col>
							</v-col>
						</v-row>
						<v-col class="ma-0 pa-0" cols="auto">
							<v-row class="ma-0 pa-0 mr-2" align="center" justify="end">
								<v-col class="ma-0 pa-0 mr-2" cols="auto">
									<v-col class="ma-0 pa-0" style="height: 40px; width: 8rem;"
										@click="onlyAdminLoginBtnCount = onlyAdminLoginBtnCount + 1">
										{{' '}}
									</v-col>
								</v-col>
								<v-col class="d-flex align-center ma-0 pa-0" cols="auto">
									<v-btn id="grey_btn" height="1.5rem"
										:href="`https://support.usen.com/?site_domain=default`"
										style="border-radius:25px;" >{{'ヘルプ・サポート'}}</v-btn>
										<v-row class="ml-2 mr-3 w-0 header_text">{{'お店の未来を創造する'}}</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>

				<v-row class="ma-0 pa-0" align="center">
					<v-col id="ueyes_icon_wrap" align="center" class="ma-0 pa-0" cols="3">
						<v-col id="ueyes_icon_box" align="center" class="ma-0 pa-0" cols="auto">
							<v-img max-height="2rem" max-width="2rem" class="ma-0 pa-0 mb-1"
								src="@/assets/images/ueyes_icon.png"></v-img>
							<v-col class="ma-0 pa-0" cols="auto">
								<v-img height="30px" width="8rem" class="ma-0 pa-0" contain
									src="@/assets/images/usen_camera_logo.png"></v-img>
							</v-col>
						</v-col>
					</v-col>
					<v-col id="login_wrap" class="ma-0 pa-0" cols="9" align="center">
						<form @submit.prevent="login">
							<v-col id="login_box" cols="auto">							
								<v-col class="ma-0 pa-0 mb-6">
									{{'ログイン'}}
								</v-col>
								<v-col class="ma-0 pa-0 mb-5" cols="auto" v-if="loginFail"
									style="color:rgb(239, 100, 102);font-size:0.85rem;">
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ログインに失敗しました。'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ユーサーID/パスワードに誤りがあります。'}}</v-col>
								</v-col>
								<v-col class="ma-0 pa-0 mb-5" cols="auto" v-if="ipCheckErrorMessage"
									style="color:rgb(239, 100, 102);font-size:0.85rem;">
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ログインに失敗しました。'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ご利用のネットワーク回線では接続を'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'許可されていません。'}}</v-col>
								</v-col>
								
								<v-col class="ma-0 pa-0" cols="auto">
									<v-col class="ma-0 pa-0" align="left">{{'ユーザーID'}}</v-col>
									<input class="input_email mb-6" type="text" v-model="username"
										ref="username" data-cy="input_email" autocapitalize="none">
								</v-col>

								<v-col class="ma-0 pa-0 mb-8" cols="auto">
									<v-col class="ma-0 pa-0" align="left">{{'パスワード'}}</v-col>
									<input class="input_password" data-cy="input_password"
										type="password" v-model="password" ref="password"
										v-on:keyup.enter="login">
								</v-col>
								<v-col id="loginCheck" class="pa-0 ml-3" cols="auto">
									<v-row class="ma-0 pa-0 pl-3" align="center">
										<input id="check_box" type="checkbox" v-model="keepLoginCheck" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{'ID/パスワードを保持する'}}</v-col>
									</v-row>
								</v-col>
								<v-col class="mt-8" align="center">
									<v-btn id="blue_btn" class="mb-6" elevation="2" width="11rem" height="2.5rem"
										style="font-size:1.1rem;" data-cy="login_btn"
										:loading="loading" @click="login">{{'ログイン'}}</v-btn>
								</v-col>
								<v-col class="ma-0 pa-0 mt-6">
									<v-btn id="back_clean_btn" elevation="0" width="17rem" height="2.5rem"
										style="font-size:0.8rem;" 
										:href="`https://umembers.usen.com/forgot-pass`" target="_blank">
										<v-row class="ma-0 pa-0" align="center">
											{{'パスワードのみを忘れた方はコチラ'}}
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 ml-2"
												src="@/assets/images/blue_right_icon.png"></v-img>
										</v-row>
									</v-btn>
									<!-- <v-btn id="back_clean_btn" elevation="0" width="17rem" height="2.5rem"
										style="font-size:0.8rem;" 
										:href="`https://dev.umembers.usen.com/forgot-idpass`" target="_blank">
										<v-row class="ma-0 pa-0" align="center">
											{{'IDとパスワードを忘れた方はコチラ'}}
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 ml-2"
												src="@/assets/images/blue_right_icon.png"></v-img>
										</v-row>  
									</v-btn> -->
								</v-col>
							</v-col>
						</form>
					</v-col>
				</v-row>
			</v-col>

			<!-- ############### Mobile View ############### -->
			<v-col class="ma-0 pa-0" cols="12" v-else>
				<v-col class="ma-0 pa-0" cols="12" id="login_view_mobile">
					<v-col id="ueyes_icon_wrap_mobile" align="center" class="ma-0 pa-0" cols="12">
						<v-col id="ueyes_icon_box" align="center" class="ma-0 pa-0" cols="auto">
							<v-row class="ma-0 pa-0" align="center">
								<v-img height="2.5rem" width="2.5rem" class="ma-0 pa-0 mr-3" contain
									src="@/assets/images/ueyes_icon.png"></v-img>
								<v-col class="ma-0 pa-0" cols="auto" style="font-size:1.5rem;">
									<v-img height="30px" width="8rem" class="ma-0 pa-0" contain
										src="@/assets/images/usen_camera_logo.png"></v-img>
								</v-col>
							</v-row>
						</v-col>
					</v-col>
					<v-col id="login_wrap_mobile" class="ma-0 pa-0" cols="12" align="center">
						<form @submit.prevent="login">
							<v-col id="login_box_mobile" class="pa-0" cols="auto">
								<v-col class="ma-0 pa-0 pt-10 pb-10">
									{{'ログイン'}}
								</v-col>
								<v-col class="ma-0 pa-0 mb-3" cols="auto" v-if="loginFail"
									style="color:rgb(239, 100, 102);font-size:0.8rem;">
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ログインに失敗しました。'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ユーサーID/パスワードに誤りがあります。'}}</v-col>
								</v-col>
								<v-col class="ma-0 pa-0 mb-3" cols="auto" v-if="ipCheckErrorMessage"
									style="color:rgb(239, 100, 102);font-size:0.8rem;">
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ログインに失敗しました。'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'ご利用のネットワーク回線では接続を'}}</v-col>
									<v-col class="ma-0 pa-0" align="left" cols="auto">{{'許可されていません。'}}</v-col>
								</v-col>
								<v-col class="ma-0 pa-0 pb-3" cols="auto">
									<v-col class="ma-0 pa-0" align="left">{{'ユーザーID'}}</v-col>
									<input class="input_email" type="text" v-model="username"
										ref="username" autocapitalize="none">
								</v-col>
								<v-col class="ma-0 pa-0 pb-9" cols="auto">
									<v-col class="ma-0 pa-0" align="left">{{'パスワード'}}</v-col>
									<input class="input_password"
										type="password" v-model="password" ref="password"
										v-on:keyup.enter="login">
								</v-col>
								<v-col id="loginCheck" class="ma-0 pa-0" cols="12">
									<v-row class="ma-0 pa-0" align="center" justify="center">
										<v-col class="ma-0 pa-0 pr-2" cols="1">
											<input id="check_box" type="checkbox" v-model="keepLoginCheck" />
										</v-col>
										<v-col class="ma-0 pa-0" cols="auto">{{'ID/パスワードを保持する'}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0 pt-9">
									<v-btn id="blue_btn" elevation="2" width="11rem" height="2.5rem"
										style="font-size:1.1rem;"
										:loading="loading" @click="login">{{'ログイン'}}</v-btn>
								</v-col>							
								<v-col class="ma-0 pa-0 pt-10">
									<v-btn id="back_clean_btn" elevation="0" width="17rem" height="2.5rem"
										style="font-size:0.8rem;"
										:href="passwordUrl" target="_blank">
										<v-row class="ma-0 pa-0" align="center">
											{{'パスワードのみを忘れた方はコチラ'}}
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 ml-2"
												src="@/assets/images/blue_right_icon.png"></v-img>
										</v-row>
									</v-btn>
									<!-- <v-btn id="back_clean_btn" elevation="0" width="17rem" height="2.5rem"
										style="font-size:0.8rem;"
										:href="`https://dev.umembers.usen.com/forgot-idpass`" target="_blank">
										<v-row class="ma-0 pa-0" align="center">
											{{'IDとパスワードを忘れた方はコチラ'}}
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 ml-2"
												src="@/assets/images/blue_right_icon.png"></v-img>
										</v-row>
									</v-btn> -->
									<!-- 막음. -->
									<!-- <v-btn id="back_clean_btn" elevation="0" width="17rem" height="2.5rem"
										class="mt-5" style="font-size:0.8rem;color:white;">
										<v-row class="ma-0 pa-0" align="center">
											<v-icon class="ma-0 pa-0 mr-1" dark>mdi-help-circle-outline</v-icon>
											{{'ヘルプ・サポートはコチラ'}}
										</v-row>
									</v-btn> -->
								</v-col>
							</v-col>
						</form>
					</v-col>
				</v-col>
			</v-col>
		</v-container>
	</v-main>
</template>

<script>
import 'dotenv/config'
import mixin from '@/mixin';
import { loginAfterProcess } from './loginAfterProcess'
import $ from 'jquery';
import { ERROR_IP_CHECK } from '@/constants';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	props: {
		//로그아웃후 로그인페이지로 연결됬을때 true
    fromLogout: { type: Boolean, default: false },
		autoLogout: { type: Boolean, default: false }
  },
	data: () => ({
		username: '',
		password: '',
		loginFail: false,
		loading: false,
		keepLoginCheck: false,
		backBtnClickCount: 0,
		fromHome: false,
		adminLoginBtnCount: 0,
		onlyAdminLoginBtnCount: 0,
		loginTime: 0, // milliseconds
		ipCheckErrorMessage: '',
		passwordUrl: `https://dev.umembers.usen.com/forgot-pass`,
	}),
	beforeRouteEnter(to, from, next) {
    next((vm) => {
			if(from.path == '/home') {
				vm.fromHome = true;
			}
    });
  },
	watch: {
		'adminLoginBtnCount': function(item) {
			if(item == 10) {
				this.adminLogin();
				this.adminLoginBtnCount = 0;
			}
		},
		'onlyAdminLoginBtnCount': function(item) {
			if(item == 10) {
				this.onlyAdmin();
				this.onlyAdminLoginBtnCount = 0;
			}
		},
	},
	created() {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.getRegistrations().then(function(registrations) {
				for(let registration of registrations) {
					registration.unregister()
				} 
			}).catch(function(err) {
				console.log('Service Worker registration failed: ', err);
			});			
		} else {
			console.log('Service Worker is not supported');
		}
	},
	async mounted() {
		console.log('%cMobile - ' + this.$store.state.isMobile.toString(), "color:#008DD0;");
		this.setPasswordUrl();
		let vh = window.innerHeight * 0.01;
  	document.documentElement.style.setProperty('--vh', `${vh}px`);
		if(this.$store.state.isMobile == false) {
			if(this.fromLogout == true) {
				window.onpopstate = (event) => {
					this.replaceRoute("/login", {});
				}
			}
		}

		this.username = this.$refs.username.value;
		this.password = this.$refs.password.value;
		
		if(this.autoLogout == false) this.checkLocalTokenAndLoginProcess();

		let keepLoginCheck = await localStorage.getItem("ueyesKeepLogin");
    let userData = await JSON.parse(localStorage.getItem("ueyesUser"));
		if(userData != null) {
			if(keepLoginCheck == 'true') {
				this.keepLoginCheck = true;
				this.username = Buffer.from(userData.userName, "base64").toString('utf8'),
				this.password = Buffer.from(userData.password, "base64").toString('utf8');
			}
		}
		// URL의 해시 부분에서 쿼리 스트링을 추출
		const hash = window.location.hash;
		const queryString = hash.substring(hash.indexOf('?') + 1); // '?' 이후의 문자열을 모두 가져옴
		const urlParams = new URLSearchParams(queryString);
		const error = urlParams.get('error');

		if (ERROR_IP_CHECK === error) {
				this.ipCheckErrorMessage = ERROR_IP_CHECK;
		}
	},
	methods: {
		initializeErrorState() {
			this.loginFail = false;
			this.ipCheckErrorMessage = '';
		},
		// password url을 process.env.VUE_APP_ENVIRONMENT에 따라 다르게 설정
		setPasswordUrl() {
			if (process.env.VUE_APP_ENVIRONMENT === 'PRODUCTION') {
				this.passwordUrl = `https://umembers.usen.com/forgot-pass`;
			} else if (process.env.VUE_APP_ENVIRONMENT === 'STAGING') {
				this.passwordUrl = `https://stg.umembers.usen.com/forgot-pass`;
			} else {
				// DO nothing
			}
		},
		async login() {
			if(this.username == '') {
				this.showToastMessage(this.tmb('pleaseInputUserId'));
				return;
			}
			else if(this.password == '') {
				this.showToastMessage(this.tmb('pleaseInputPassword'));
				return;
			}
			this.loading = true;
			this.initializeErrorState();
			let params = {
				userName: this.username,
				password: this.password,
				all: false
			};
			await this.networkController.login(params).then(async (res) => {
				await loginAfterProcess(this, res.data, false)
					.then(response => {
						this.checkKeepLogin();
					})
					.catch(error => {
						this.loading = false;
						this.ipCheckErrorMessage = ERROR_IP_CHECK;
					})
			}).catch(error => {
				this.loginFail = true;
				this.loading = false;
      });
		},
		checkKeepLogin() {
			if(this.keepLoginCheck == true) {
				let encodedParams = {
					userName: Buffer.from(this.username, "utf8").toString('base64'),
					password: Buffer.from(this.password, "utf8").toString('base64'),
				}
				localStorage.setItem("ueyesKeepLogin", this.keepLoginCheck);
      	localStorage.setItem('ueyesUser', JSON.stringify(encodedParams));
			}
		},
		checkLocalTokenAndLoginProcess() {
			let auth = JSON.parse(localStorage.getItem('auth'));
			if(auth != null) {
				let currentDateTime = Date.now();
				let expired = auth.expired;
				let expiredSetTime = new Date(expired).getTime();
				if(expiredSetTime > currentDateTime) {
					// jwt 유효기간이 유효한 경우 대시보드로 페이지 이동
					const res = { data: auth };
					loginAfterProcess(this, res.data, false);
					$('#login_view').css('display','none'); //display none
					$('#login_view_mobile').css('display','none'); //display none
				}
			}
		},
		async adminLogin() {
			console.log('%cHidden Admin login', "color:#008DD0;");
			if(this.username == '') {
				this.showToastMessage(this.tmb('pleaseInputUserId'));
				return;
			}
			else if(this.password == '') {
				this.showToastMessage(this.tmb('pleaseInputPassword'));
				return;
			}
			this.loading = true;
			this.initializeErrorState();
			let params = {
				userName: this.username,
				password: this.password,
				all: true
			};

			await this.networkController.login(params).then(async (res) => {
				loginAfterProcess(this, res.data, true);
			}).catch(error => {
        const message = error.response.data.msg;
				this.$dialog.message.error(message, {position: 'top', timeout: 2000});
				this.loginFail = true;
				this.loading = false;
      });
		},
		async onlyAdmin() {
			this.initializeErrorState();
			console.log('%cBeyless Admin login', "color:#008DD0;");
			await this.$store.commit('setUser', {
				unisCustomerName: 'Beyless',
				admin: false,
				onlyAdmin: true, tokenDecode: { role: '10' },
			});
			this.$dialog.message.info('Beyless 관리자 로그인 성공', {
				position: 'top', timeout: 2000
			});
			this.replaceRoute("/admin/test-device-data", {});
		},
	}
}
</script>

<style lang="scss" scoped>
#login_view {
	min-width: 700px;
	min-height: 800px;
}
#login_view_mobile {
	// height: calc(var(--vh, 1vh) * 100);
	height: 100vh;
}
#header {
	background-color: #000000;
	color: white;
	height: 40px;
}
#ueyes_icon_wrap {
	background: linear-gradient(to bottom right, #9225E5, #1B038D);
	height: calc(100vh - 40px);
	min-height: 800px;
	position: relative;
}
#ueyes_icon_wrap_mobile {
	background: linear-gradient(to bottom right, #9225E5, #1B038D);
	height: 15%;
	position: relative;
}
#ueyes_icon_box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 4;
}
#login_wrap {
	background-color: #222222;
	height: calc(100vh - 40px);
	min-height: 800px;
}
#login_wrap_mobile {
	background-color: #222222;
	// 모바일 가로화면 스크롤시 흰색으로 나오는 것 수정
	display: block;
	overflow: auto;
	height: 85%;
}
#login_box {
	margin-top: 10rem;
	margin-left: auto;
	margin-right: auto;
	width: 17rem;
}
#login_box_mobile {
	margin-left: auto;
	margin-right: auto;
	width: 90%;
}
.input_email {
	border-radius: 4px;
	border: 1px solid #4A4A4A;
	width: 100%;
	background: #272727;
	padding-left: 7px;
	color: white;
	height: 2rem;
	// background-image: url("../../assets/images/login_ico_user.png");
	// background-repeat: no-repeat;
	// background-position: 10px center;
}
.input_password {
	border-radius: 4px;
	border: 1px solid #4A4A4A;
	width: 100%;
	background: #272727;
	padding-left: 7px;
	color: white;
	height: 2rem;
}
#loginCheck {
	color: #008DD0;
}
::v-deep .theme--dark.v-label {
	color: #008DD0;
}
#back_clean_btn {
	color: #008DD0;
}

.header_logo{
	width: 148px;
}
.header_text{
	z-index: 3;
	}


// 여기
@media ( max-width: 768px ) {
	.input_email {
		width: 100%;
	}
	.input_password {
		width: 100%;
	}
	.header_logo{
		width: 85px;
	}
	.header_text{
		font-size: 12px;
	}	

}

</style>
